export default "__VITE_PUBLIC_ASSET__a6b21353__"